import { Badge, Flex, Tab, Tabs, TabList, TabPanel, TabPanels, Text } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PageBanner from '../../../components/pageBanner/PageBanner';
import PageContainer from '../../../components/pageContainer/PageContainer';
import AccountsInfoTable from './AccountsInfoTable';
import UpgradeAccountRequestTable from './UpgradeAccountRequestTable';
import SectorManager from './SectorManager';
import AdminApiKeys from './AdminApiKeys';
import RoleManager from './RoleManager';
import { getAccountsInfo } from '../../../slice/adminHomeSlice';

function AdminHome() {
  const dispatch = useDispatch();
  const pendingUpgradeRequests = useSelector(state => state.adminHome.pendingUpgradeRequests);

  useEffect(() => {
    dispatch(getAccountsInfo());
  }, [dispatch]);

  return (
    <PageContainer>
      <PageBanner/>
      <Flex align='center' justify='center' w='70%' direction='column'>
        <Tabs>
          <TabList>
            <Tab><Text color='#3483be' align='left' fontWeight='bold' fontSize={16}>Accounts</Text></Tab>
            <Tab>
              <Flex align='center' gap={2}>
                <Text color='#3483be' align='left' fontWeight='bold' fontSize={16}>Accounts Upgrade Requests</Text>
                {pendingUpgradeRequests > 0 && (
                  <Badge colorScheme='red' borderRadius='full' px={2} py={0.5}>
                    {pendingUpgradeRequests}
                  </Badge>
                )}
              </Flex>
            </Tab>
            <Tab><Text color='#3483be' align='left' fontWeight='bold' fontSize={16}>Sectors</Text></Tab>
            <Tab><Text color='#3483be' align='left' fontWeight='bold' fontSize={16}>API Keys</Text></Tab>
            <Tab><Text color='#3483be' align='left' fontWeight='bold' fontSize={16}>Roles</Text></Tab>
          </TabList>

          <TabPanels>
            <TabPanel>
              <AccountsInfoTable/>
            </TabPanel>
            <TabPanel>
              <UpgradeAccountRequestTable/>
            </TabPanel>
            <TabPanel>
              <SectorManager />
            </TabPanel>
            <TabPanel>
              <AdminApiKeys />
            </TabPanel>
            <TabPanel>
              <RoleManager />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Flex>
    </PageContainer>
  );
}

export default AdminHome;
